import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Avtar from "../../../asset/avtar.png";
import badge from "../../../asset/badge.svg";
import tickMark from "../../../asset/tickMark.svg";
import "./JobDetailsModal.scss";
import graphqlRequest from "../../../requestMethod";
import { message } from "../../Common/SnakeAlert/SnakeAlert";
import AcceptApplicationDialog from "./AcceptApplicationDialog";
import star from "../../../asset/postjob/star.svg";
const getRandomNumber = () => Math.floor(Math.random() * 5) + 1;

const MobileProfileDetails = ({
  selectedData,
  selectedRecommendedUser,
  handleAccept,
  handleReject,
  handleShortlist,
  handleInterview,
  // handlejobInvite,
  handleDownLoadResume: propHandleDownloadResume,
  handleDownloadRegistration: propHandleDownloadRegistration,
  isresumeDownloading: propIsResumeDownloading,
  isregistrationDownloading: propIsRegistrationDownloading,
  // valueToBeMatched,
  onAccept,
  onReject,
  onInvite,
  handleCloseDetail,
  fetchOpenJob
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { profile, type  } = location.state || {};
  const data = localStorage.getItem("auth");
  const token = JSON.parse(data)?.accessToken;
  let [selectedProfile, setSelectedProfile] = useState({});
  // console.log("slected====",selectedProfile);
    const [openAcceptDialog, setOpenAcceptDialog] = useState(false);


  const [isResumeDownloading, setIsResumeDownloading] = useState(propIsResumeDownloading || false);
  const [isRegistrationDownloading, setIsRegistrationDownloading] = useState(propIsRegistrationDownloading || false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isInviting, setIsInviting] = useState(false);
  const [valueToBeMatchedState, setValueToBeMatchedState] = useState(  false);

  // State for job details and applications
  const [jobDetails, setJobDetails] = useState(null);
  const [applications, setApplications] = useState([]);
    let [invitedUser1, setInvitedUser1] = useState([]);
    let invitedUser = [];
    let [whetherInvitedUser, setWhetherInvitedUser] = useState([]);
      const [inviting, setInviting] = useState(false);
  const randomNumber = getRandomNumber();
    

  const getProfileData = () => {
    if (type === "application") {
      return {
        name: profile?.professional?.name?.full,
        qualification: profile?.professional?.qualification?.name,
        experience: profile?.professional?.numExperience?.name,
        avatar: profile?.professional?.avatar?.url || Avtar,
        marksPercentage: profile?.professional?.marksPercentage,
        jobHistory: profile?.professional?.profile?.jobHistory,
        education: profile?.professional?.profile?.education,
        id: profile?.id,
        specialization: profile?.professional?.specialization?.name,
        professionalWorkedHour: profile?.professional?.professionalWorkedHour,
        listTopHospitals: profile?.professional?.listTopHospitals,
      };
    } else {
      return {
        name: profile?.name?.full,
        qualification: profile?.qualification?.name,
        experience: profile?.numExperience?.name,
        avatar: profile?.avatar?.url || Avtar,
        marksPercentage: profile?.marksPercentage,
        jobHistory: profile?.profile?.jobHistory,
        education: profile?.profile?.education,
        id: profile?.id,
        specialization: profile?.specialization?.name,
        professionalWorkedHour: profile?.professionalWorkedHour,
        listTopHospitals: profile?.listTopHospitals,
      };
    }
  };

  const profileData = getProfileData();
  // console.log("profileData=====", profile);

  const setStateColor = (state) => {
    if (state === "OPEN") return "#FAEDCD";
    if (state === "ACCEPTED") return "#BBD6B8";
    if (state === "REJECTED") return "#FFB4B4";
    if (state === "PENDING_TEST") return "#FFB4B4";
    if (state === "REVIEW") return "#F3DEBA";
    if (state === "PENDING_INTERVIEW") return "#C9EEFF";
    if (state === "WITHDRAW") return "#FFB4B4";
  };




  // Fetch job details
  const fetchSelectedJobDetails = async () => {
    if (!profile?.id) return;
    
    try {
      const query = `
        {
          withAuth(token: "${token}") {
            getJob(id: "${selectedData?.id}") {
              id
              state
              code
              jobDescription
                recommendedUsers{
              user{id},
              isApplied
            }
              numberOfJobs
              organization {
                id
                name
                companyType {
                  id
                  name
                }
              }
             department {
              id
              departmentType {
                name
              }
              branch {
                company {
                  id
                  name
                }
                brand
                subBrand
                jobLocation {
                  hospitalName
                  branchName
                }
              }
            }
              qualification {
                id
                name
              }
              minRate
              maxRate
              shift
              shiftLogs {
                startTime {
                  ts
                }
                endTime {
                  ts
                }
              }
            }
          }
        }
      `;
      
      const response = await graphqlRequest(query);
      setJobDetails(response?.data?.withAuth?.getJob || null);
      setWhetherInvitedUser(
        response?.data?.withAuth?.getJob?.recommendedUsers
      );
    } catch (error) {
      console.error("Error fetching job details:", error);
      message.error("Failed to load job details");
    }
  };
  
  // Fetch applications for the job
  const fetchApplications = async () => {
    if (!profile?.id) return;
    
    try {
      const query = `
        query {
          withAuth(token: "${token}") {
            listNurseApplications(job: "${selectedData?.id}") {
              id
              state
              professional {
                id
                name {
                  full
                }
                qualification {
                  name
                }
                specialization {
                  name
                }
                numExperience {
                  name
                }
              }
              appliedAt {
                ts
              }
            }
          }
        }
      `;
      
      const response = await graphqlRequest(query);
      // console.log("listNurseApplications===", response.data.withAuth.listNurseApplications)
         
      setApplications(response?.data?.withAuth?.listNurseApplications || []);
      if (Object.keys(profile)?.length > 0) {
        setSelectedProfile(
          response?.data?.withAuth?.listNurseApplications.filter(
            (data) => profile.id === data.id && data
          )[0]
        );
      }
    } catch (error) {
      console.error("Error fetching applications:", error);
      message.error("Failed to load applications");
    }
  };
  
  // Call these functions when the component mounts or when the profile changes
  useEffect(() => {
    if (profile?.id) {
      fetchSelectedJobDetails();
      fetchApplications();
    }
  }, [profile?.id]);



  // Handle accepting the application
  const handleAcceptApplication = async () => {
    if (!profile?.id) return;
    
    setIsProcessing(true);
    
      setOpenAcceptDialog(true); // this opens the dialog
  
  
  
    // try {
    //   const query = `
    //     mutation {
    //       mutationWithAuth(token: "${token}") {
    //         update {
    //           approveApplicationV1(application: "${profile.id}")
    //         }
    //       }
    //     }
    //   `;
      
    //   const response = await graphqlRequest(query);
    //   if (response?.data?.mutationWithAuth?.update?.approveApplicationV1) {
    //     message.success("Application accepted successfully");
        
    //     // Refresh data
    //     await Promise.all([
    //       fetchSelectedJobDetails(),
    //       fetchApplications()
    //     ]);
        
    //     navigate('/locum/open-jobs');
        
    //     // If there's a parent handler, call it
    //     if (onAccept) {
    //       onAccept(profile.id);
    //     }
    //   } else {
    //     throw new Error("Failed to accept application");
    //   }
    // } catch (error) {
    //   console.error("Error accepting application:", error);
    //   message.error("Failed to accept application. Please try again.");
    // } finally {
    //   setIsProcessing(false);
    // }
  };
  const handleDialogClose = () => {
    setIsProcessing(false);

    setOpenAcceptDialog(false);
  };
    const handleDialogConfirm = async () => {
      // console.log("Confirmed with POC:", poc);
      setOpenAcceptDialog(false);
    setIsProcessing(false);

        let query = `
          mutation{
            mutationWithAuth(token: "${token}")
            {
               update{
                approveApplicationV1(application: "${profile.id}")
              }
            }
          }
          `;
  
          const response = await graphqlRequest(query);
          if (response){
        // graphqlRequest(query).then((response) => {
          // console.log("acceptResponse", response);
          if (response) {
            message.success("Accept Successfully!");
               //     // Refresh data
        await Promise.all([
          fetchSelectedJobDetails(),
          fetchApplications()
        ]);
            // fetchApplications();
            // fetchSelectedJobDetails();
  
            // if (jobDetails?.numberOfJobs === jobDetails?.roleOfferedCount) {
            //   handleCloseDetail();
            //   fetchOpenJob();
  
              navigate("/locum/open-jobs");
            // }
          }
        };
    };

  // Handle Reject Application
  const handleRejectApplication = async () => {
    if (!profile?.id) return;
    
    setIsProcessing(true);
    try {
      const query = `
        mutation {
          mutationWithAuth(token: "${token}") {
            update {
              cancelMiniJobApplication(application: "${profile.id}")
            }
          }
        }
      `;
      
      const response = await graphqlRequest(query);
      if (response?.data?.mutationWithAuth?.update?.cancelMiniJobApplication) {
        message.success("Application rejected successfully");
        
        // Refresh data
        await Promise.all([
          fetchSelectedJobDetails(),
          fetchApplications()
        ]);
        
        navigate('/locum/open-jobs');
        
        // If there's a parent handler, call it
        if (onReject) {
          onReject(profile.id);
        }
      } else {
        throw new Error("Failed to reject application");
      }
    } catch (error) {
      console.error("Error rejecting application:", error);
      message.error("Failed to reject application. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  // Handle View Resume in PDF Viewer
  const handleViewResume = async () => {
    console.log("profile???", profile);

    setIsResumeDownloading(true);
    try {
      const query = `{
        withAuth(token: "${token}") {
          getUser(id: "${profile?.professional?.id || profile?.id}") {
            documents {
              docType {
                name
              }
              files {
                secureUrl
                uri
                url
              }
            }
          }
        }
      }`;
      
      const response = await graphqlRequest(query);
      const documents = response?.data?.withAuth?.getUser?.documents || [];
      const resumeDoc = documents.find(doc => doc.docType?.name === "CV");
      
      if (resumeDoc?.files?.[0]?.url) {
        let linkSource = resumeDoc.files[0].url;
        
        // Ensure we're using HTTPS
        if (linkSource.startsWith("http://")) {
          linkSource = linkSource.replace("http://", "https://");
        }

        // Check if iOS device
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                     (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

        if (isIOS) {
          // For iOS, create a temporary anchor element and trigger a click
          const link = document.createElement('a');
          link.href = linkSource;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          
          // Add to document, trigger click, and remove
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          // For other devices, use the existing PDF viewer approach
          const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(linkSource)}`;
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            newWindow.location.href = viewerUrl;
          } else {
            // If popup is blocked, fall back to direct link
            window.location.href = linkSource;
          }
        }
      } else {
        throw new Error("No resume available to view");
      }
    } catch (error) {
      console.error("Error viewing resume:", error);
      message.error("Failed to open resume. Please try again.");
    } finally {
      setIsResumeDownloading(false);
    }
  };

  // Handle View Registration in PDF Viewer
  const handleViewRegistration = async () => {
    
    setIsRegistrationDownloading(true);
    try {
      const query = `{
        withAuth(token: "${token}") {
          getUser(id: "${profile?.professional?.id || profile?.id}") {
            documents {
              docType {
                name
              }
              files {
                secureUrl
                uri
                url
              }
            }
          }
        }
      }`;
      
      const response = await graphqlRequest(query);
      const documents = response?.data?.withAuth?.getUser?.documents || [];
      const registrationDoc = documents.find(doc => doc.docType?.name === "REGISTRATION");
      
      if (registrationDoc?.files?.[0]?.url) {
        let linkSource = registrationDoc.files[0].url;
        
        // Ensure we're using HTTPS
        if (linkSource.startsWith("http://")) {
          linkSource = linkSource.replace("http://", "https://");
        }

        // Check if iOS device
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                     (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

        if (isIOS) {
          // For iOS, create a temporary anchor element and trigger a click
          const link = document.createElement('a');
          link.href = linkSource;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          
          // Add to document, trigger click, and remove
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          // For other devices, use the existing PDF viewer approach
          const viewerUrl = `/pdf-viewer.html?pdfUrl=${encodeURIComponent(linkSource)}`;
          const newWindow = window.open('', '_blank');
          if (newWindow) {
            newWindow.location.href = viewerUrl;
          } else {
            // If popup is blocked, fall back to direct link
            window.location.href = linkSource;
          }
        }
      } else {
        throw new Error("No registration certificate available to view");
      }
    } catch (error) {
      console.error("Error viewing registration:", error);
      message.error("Failed to open registration certificate. Please try again.");
    } finally {
      setIsRegistrationDownloading(false);
    }
  };

  let valueToBeMatched;
  useEffect(() => {
      if (
        whetherInvitedUser?.find(
          (value) => value?.user?.id === profileData?.id
        )
      ) {
        invitedUser.push({
          [profileData.id]: true,
        });
        setInvitedUser1(invitedUser);
      } else {
        invitedUser.push({
          [profileData.id]: false,
        });
        setInvitedUser1(invitedUser);
      }
      // console.log(whetherInvitedUser, "Hello hehe");
      // console.log(invitedUser, "Hello hehe again");
  
     
    }, [profileData, whetherInvitedUser]);

    for (var i = 0; i <= invitedUser1.length; i++) {
      for (var key in invitedUser1[i]) {
        // console.log(invitedUser1[i][key], "o");
        valueToBeMatched = invitedUser1[i][key];
      }
    }

  // Handle Invite to Apply
  const handlejobInvite = async () => {
    console.log("selectedData?????",selectedData?.id, profileData?.id );
    setIsInviting(true);
    
    // if (!profile?.id || !profile?.id) {
    //   message.error("Missing required profile or job information");
    //   return;
    // }
    
    try {
      const query = `
      query{
        withAuth(token:"${token}"){
          inviteUserToMultipleJobs(jobIds:["${selectedData?.id}"],userId:"${profileData?.id}")
        }
      }
        
      `;
      // mutation {
      //   mutationWithAuth(token: "${token}") {
      //     update {
      //       inviteToApply(jobId: "${profile?.id}", userId: "${profile.professional.id}")
      //     }
      //   }
      // }
      const response = await graphqlRequest(query);
      
      if (response?.errors) {
        message.error("Already invited!");
        return;
      }
       if (response?.data?.withAuth?.inviteUserToMultipleJobs) {
              message?.success("Professional Invited Successfully.");
              setInvitedUser1((invitedUser1) => ({
                ...invitedUser1,
                [profileData.id]: true,
              }));
              setValueToBeMatchedState(true);
              // fetchSelectedJobDetails();
     
        // If there's a parent handler, call it
        // if (onInvite) {
        //   onInvite();
        // }
      } else {
        throw new Error("Failed to send invitation");
      }
    } catch (error) {
      console.error("Error sending invitation:", error);
      message.error("Failed to send invitation. Please try again.");
    } finally {
      setIsInviting(false);
    }
  };

  // Use prop functions if provided, otherwise use local implementations
  const finalHandleViewResume = handleViewResume;
  const finalHandleViewRegistration = handleViewRegistration;
  const finalIsResumeDownloading = isResumeDownloading;
  const finalIsRegistrationDownloading = isRegistrationDownloading;

  const togglePopup = (event) => {
    event.preventDefault(); // Prevent any default behavior
    event.stopPropagation(); // Stop event bubbling to parent elements
    // console.log("Button Clicked! isPopupOpen:", isPopupOpen); // Debug click
    setIsPopupOpen((prev) => {
      // console.log("Setting isPopupOpen to:", !prev); // Debug state change
      return !prev;
    });
  };
  
  const headerStyle = {
    padding: "12px 16px",
    borderBottom: "1px solid #ddd",
    textAlign: "left",
    fontWeight: "600",
    color: "#444",
  };

  const cellStyle = {
    padding: "12px 16px",
    color: "#333",
    wordBreak: "break-word",
  };

  const randomMapRef = React.useRef({});
  
    const getRandomForProfile = (profileId) => {
      if (!randomMapRef.current[profileId]) {
        randomMapRef.current[profileId] =
          Math.floor(Math.random() * 5) + 1;
      }
      return randomMapRef.current[profileId];
    };
    const rating = getRandomForProfile(selectedProfile?.id);

  return (
    <div className="mobile-profile-details">
      <Box sx={{ padding: "10px" }}>
        <Button
          onClick={() => navigate(-1)}
          sx={{ marginBottom: "10px", justifyContent: "flex-start" }}
        >
          Back
        </Button>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            padding: "10px",
            backgroundColor: "#f5f5f5",
            borderRadius: "8px",
          }}
        >
          <Box sx={{ display: "flex", gap: "10px" }}>
            <Box sx={{ position: "relative" }}>
              {profileData?.marksPercentage >= 60 && (
                <div
                  className="dp-badge-hover"
                  data-message="Jobizo Assessment Qualified"
                >
                  <img src={badge} className="dp-badge" alt="badge" />
                </div>
              )}
              <img
                src={profileData?.avatar}
                className={
                  profileData?.marksPercentage >= 60 ? "badge-border" : ""
                }
                alt="profile"
                style={{ width: "80px", height: "80px", borderRadius: "50%" }}
              />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h8">
                {profileData?.name}
                <img src={tickMark} className="dp-tickmark" alt="tick" />
                {selectedProfile?.state && (
                  <span 
                    style={{
                      backgroundColor: setStateColor(selectedProfile.state),
                      color: '#000',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      marginLeft: '8px',
                      fontWeight: 'normal',
                      verticalAlign: 'middle',
                      display: 'inline-flex',
                      alignItems: 'center',
                      height: '20px'
                    }}
                  >
                    {selectedProfile?.state === "OPEN"
                                    ? "APPLIED"
                                    : selectedProfile?.state ===
                                      "PENDING_INTERVIEW"
                                    ? "PENDING INTERVIEW"
                                    : selectedProfile?.state === "PENDING_TEST"
                                    ? "PENDING TEST"
                                    : selectedProfile?.state}
                  </span>
                )}
              </Typography>
              <h3>
                              <>
                              {Array.from({
                            length: Math.min(5, Math.max(3, rating || 0)),
                          }).map((_, index) => (
                            <img key={index} src={star} alt="star" />
                          ))}
                              </>
                                </h3>
              {profileData?.qualification && (
                <Typography>
                  Qualification: {profileData?.qualification}
                </Typography>
              )}
              {profileData?.experience && (
                <Typography>Experience: {profileData?.experience}</Typography>
              )}
              {profileData?.specialization && (
                <Typography>
                  Specialization: {profileData?.specialization}
                </Typography>
              )}
              {profileData?.professionalWorkedHour != "0 hours" && (
                <Typography>
                  Total Locum Hours: {profileData.professionalWorkedHour}
                </Typography>
              )}
              {profileData?.listTopHospitals?.length > 0 && (
                <Typography>
                  <div style={{ position: "relative", zIndex: 999 }}>
                    <p style={{ margin: 0 }}>
                      <strong>Professional Top Hospital Worked:</strong>{" "}
                      <button
                        type="button"
                        onClick={togglePopup}
                        style={{
                          color: "#007bff",
                          textDecoration: "underline",
                          background: "none",
                          border: "none",
                          fontSize: "14px",
                          cursor: "pointer",
                        }}
                      >
                        See Hospital Details
                      </button>
                    </p>

                    {isPopupOpen && (
                      <div
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          width: "100vw",
                          height: "100vh",
                          backgroundColor: "rgba(0, 0, 0, 0.6)",
                          zIndex: 1000,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          paddingTop: "40px",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#fff",
                            width: "90%",
                            maxWidth: "800px",
                            borderRadius: "12px",
                            overflow: "hidden",
                            boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
                            position: "relative",
                            maxHeight: "85vh",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {/* Close Button */}
                          <button
                            onClick={togglePopup}
                            style={{
                              position: "absolute",
                              top: "16px",
                              right: "20px",
                              fontSize: "32px",
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: "#333",
                            }}
                          >
                            ×
                          </button>

                          {/* Title */}
                          <div
                            style={{
                              padding: "24px 20px 12px",
                              borderBottom: "1px solid #e0e0e0",
                              textAlign: "center",
                            }}
                          >
                            <h2
                              style={{
                                margin: 0,
                                fontSize: "20px",
                              }}
                            >
                              Hospital List
                            </h2>
                          </div>

                          {/* Table Section (no left/right padding) */}
                          <div
                            style={{
                              overflowY: "auto",
                              width: "100%",
                            }}
                          >
                            <table
                              style={{
                                width: "100%",
                                borderCollapse: "collapse",
                                fontSize: "15px",
                              }}
                            >
                              <thead>
                                <tr
                                  style={{
                                    backgroundColor: "#f7f7f7",
                                  }}
                                >
                                  {/* <th style={headerStyle}>#</th> */}
                                  <th style={headerStyle}>Hospital Name</th>
                                  <th style={headerStyle}>Location</th>
                                </tr>
                              </thead>
                              <tbody>
                                {profileData?.listTopHospitals.map(
                                  (hospital, index) => (
                                    <tr
                                      key={index}
                                      style={{
                                        borderBottom: "1px solid #eee",
                                      }}
                                    >
                                      {/* <td style={cellStyle}>
                                                      {index + 1}
                                                    </td> */}
                                      <td style={cellStyle}>{hospital.name}</td>
                                      <td style={cellStyle}>
                                        {hospital.location}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </Typography>
              )}
            </Box>
          </Box>

          {type === "application" && (
            <Box sx={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
              <Button
                variant="contained"
                color="error"
                onClick={handleRejectApplication}
                disabled={isProcessing ||selectedProfile?.state === "ACCEPTED" || selectedProfile?.state === "REJECTED" }
                sx={{
               
                backgroundColor: selectedProfile?.state === "ACCEPTED" || selectedProfile?.state === "REJECTED" ? 'grey' : '#FF4D4F',
                  '&:hover': { backgroundColor: '#FF7875' },
                  flex: 1
                }}
              >
                {isProcessing ? 'Processing...' : 'Reject'}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAcceptApplication}
                disabled={isProcessing ||selectedProfile?.state === "ACCEPTED" || selectedProfile?.state === "REJECTED" }
                sx={{
                  backgroundColor: selectedProfile?.state === "ACCEPTED" || selectedProfile?.state === "REJECTED" ? 'grey' : '#52C41A',
                  '&:hover': { backgroundColor: '#3e9920' },
                  flex: 1
                }}
              >
                {isProcessing ? 'Processing...' : 'Accept'}
              </Button>
                   {openAcceptDialog && (
                                                <AcceptApplicationDialog
                                                  open={openAcceptDialog}
                                                  onClose={handleDialogClose}
                                                  onConfirm={handleDialogConfirm}
                                                  applicant={{
                                                    id: profile?.id,
                                                    name: profile?.professional?.name
                                                      ?.full,
                                                    degree:
                                                      profile?.professional
                                                        ?.qualification?.name,
                                                    designation:
                                                      profile?.professional
                                                        ?.specialization?.name,
                                                    avatar:
                                                      profile?.professional?.avatar
                                                        ?.url || "",
                                                  }}
                                                  defaultPoc={
                                                    profile?.job?.contactDetail
                                                  }
                                                />
                                              )}
              {/* <Button
                variant="contained"
                color="primary"
                onClick={handleInterview}
                sx={{ flex: 1 }}
              >
                Schedule Interview
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleShortlistApi(profileData.id)}
                sx={{ flex: 1 }}
              >
                Shortlist
              </Button> */}
            </Box>
          )}

          {type === "suggested" && (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {valueToBeMatchedState|| valueToBeMatched ? (
                <Button style={{ width: 140,
                  height: 55,
                  borderRadius: 8,
                  backgroundColor: 'green',
                  color: 'white',
                  fontWeight: 600,
                  fontSize: 16,
                  lineHeight: 21.79,
                  // outline: none,
                  }} variant="contained" disabled>
                  Invited
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlejobInvite}
                  disabled={isInviting}
                >
                  {isInviting ? 'Sending...' : 'Invite to Apply'}
                </Button>
              )}
            </Box>
          )}
        </Box>

        <Box sx={{ marginTop: "20px" }}>
          <Accordion>
            <AccordionSummary 
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography 
                sx={{
                  fontWeight: "bold",
                  fontSize: "18px !important",
                }}
              >
                Previous Experience
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {profileData?.jobHistory?.map((item, index) => (
                <Box key={index} className="previous-experience-container" sx={{ mb: 3 }}>
                  {item?.hospital && (
                    <Typography 
                      variant="h6" 
                      sx={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        mb: 1
                      }}
                    >
                      {item.hospital}
                    </Typography>
                  )}
                  <Box className="pe-info-details">
                    <ul style={{ paddingLeft: "20px", margin: 0 }}>
                      {item.department && (
                        <li>
                          <Typography sx={{ fontSize: "18px" }}>
                            Department: {item?.department}
                          </Typography>
                        </li>
                      )}
                      {item.specialisation && (
                        <li>
                          <Typography sx={{ fontSize: "18px" }}>
                            Specialization: {item?.specialisation}
                          </Typography>
                        </li>
                      )}
                      {item.start && !isNaN(Number(item.start)) && (
                        <li>
                          <Typography sx={{ fontSize: "18px" }}>
                            Job Start Month/Year: {new Date(Number(item.start)).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                          </Typography>
                        </li>
                      )}
                      {item.end && !isNaN(Number(item.end)) && (
                        <li>
                          <Typography sx={{ fontSize: "18px" }}>
                            Job End Month/Year: {new Date(Number(item.end)).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}
                          </Typography>
                        </li>
                      )}
                    </ul>
                  </Box>
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>

          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography  sx={{
                  fontWeight: "bold",
                  fontSize: "18px !important",
                }}>Education</Typography>
            </AccordionSummary>
            <AccordionDetails>
              {profileData?.education?.map((item, index) => (
                <Box key={index} sx={{ marginBottom: "10px" }}>
                  <Typography>
                    {item?.name}: {item?.year}
                  </Typography>
                </Box>
              ))}
            </AccordionDetails>
          </Accordion>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <Button
            variant="outlined"
            onClick={finalHandleViewResume}
            disabled={finalIsResumeDownloading}
            sx={{ marginTop: '20px' }}
          >
            {finalIsResumeDownloading ? 'Opening...' : 'View Resume'}
          </Button>
          <Button
            variant="outlined"
            onClick={finalHandleViewRegistration}
            disabled={finalIsRegistrationDownloading}
            sx={{ marginTop: '10px' }}
          >
            {finalIsRegistrationDownloading ? 'Opening...' : 'View Registration Certificate'}
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default MobileProfileDetails;
